export default __webpack_public_path__ + "static/media/mockCommon.0b8e6b26.png";